import * as React from 'react';
import ModuleWithCallToAction from './CallToActions/ModuleWithCallToAction';
import { ModuleWithRolesCheck } from './RolesCheck/ModuleWithRolesCheck';
import routes from 'components/App/components/routes';

type Props = {
    hasDecision: boolean;
    isDecisionUser: boolean;
    isSupportUser: boolean;
    children: React.ReactNode;
};

/**
 * Component to wrap decision's routes to check:
 *  - if client has access to module,else display CTA
 *  - if user has access to module, else display forbidden page
 *  - support users always have access to decision
 */
const DecisionWithAccessCheck: React.FC<Props> = ({
    hasDecision,
    isDecisionUser,
    isSupportUser,
    children,
}: Props) => {
    if (isSupportUser) return <>{children}</>;
    return (
        <ModuleWithCallToAction
            hasModule={hasDecision}
            redirectionUrl={routes.decisionCta}
        >
            <ModuleWithRolesCheck
                module="decision"
                hasModule={hasDecision}
                isModuleUser={isDecisionUser}
            >
                {children}
            </ModuleWithRolesCheck>
        </ModuleWithCallToAction>
    );
};

export default DecisionWithAccessCheck;
